import { isReactive, toRaw } from 'vue'

// see https://stackoverflow.com/questions/73063744/in-vue3-how-to-convert-nested-proxy-objects-reactive-data-to-regular-objects

export function isObject(value: unknown): boolean {
  return value !== null && !Array.isArray(value) && typeof value === 'object'
}

export function getRawData<T>(data: T): T {
  return isReactive(data) ? toRaw(data) : data
}

export function toDeepRaw<T>(data: T): T {
  const rawData = getRawData<T>(data)

  for (const key in rawData) {
    const value = rawData[key]

    if (!isObject(value) && !Array.isArray(value)) {
      continue
    }

    rawData[key] = toDeepRaw<typeof value>(value)
  }

  return structuredClone(rawData)
}
